import React, { useState, useEffect } from 'react';
import {useHistory, useParams} from 'react-router-dom';
import GuestBar from "../../components/GuestInfo/GuestBar";
import {
  Breadcrumbs, Button, Container, FormControl, FormControlLabel, ListItem, Paper, Radio, RadioGroup,
  Typography,
} from "@mui/material";
import {
  getPreviousStep,
  getStepFromUrl, isDealerSite,
  requestApi,
  restartBooking,
  showAlertAutoDis
} from "../../utils/utils";
import {useDispatch, useSelector} from "react-redux";
import Grid from "@mui/material/Grid";
import {setStep} from "../../redux/actions/stepActions";
import Itinerary from "../../components/Booking/DayTripBooking/Itinerary";
import ActivityBookingReview from "../../components/Booking/DayTripBooking/ActivityBookingReview";
import DayTripStepper from "../../components/Booking/DayTripBooking/DayTripStepper";
import {setBookingType} from "../../redux/actions/tripActions";
import {getActivityList} from "../../redux/actions/activitiesActions";
import {setTransactionClient} from "../../redux/actions/transactionActions";


const DayTripReviewPage = ({history}) => {
  const dispatch = useDispatch();
  const transactions = useSelector(state => state.transactions);
  const step = useSelector(state => state.step);
  const prefixUrl = 'booking/day-trips';
  const historyUrl = useHistory();
  const prevStep = getPreviousStep(step);
  const bookingType = useSelector(state => state.bookingType);
  const totals = useSelector((state) => state.totalsExtras);
  const [clientName, setClientName] = useState('');
  const [clientBookingRef, setClientBookingRef] = useState('');

  useEffect(() => {
    setClientName(transactions?.client?.clientName ?? '');
    setClientBookingRef(transactions?.client?.clientBookingRef ?? '');
  }, [transactions]);

  useEffect(() => {
    const currentClient = transactions?.client || {};

    const isDifferent =
        clientName !== currentClient.clientName ||
        clientBookingRef !== currentClient.clientBookingRef;

    if (isDealerSite() && clientName && clientBookingRef && isDifferent) {
      dispatch(setTransactionClient(clientName, clientBookingRef));
    }
  }, [clientName, clientBookingRef, transactions]);



  const setBooking = (e) => {
      const type = e.target.value;
      dispatch(setBookingType(type));
  };
  useEffect(() => {
    dispatch(getActivityList())
  }, []);
  useEffect(() => {
    const stepNum = getStepFromUrl(history.location.pathname);
    dispatch(setStep(stepNum));
  }, []);

  const goBack = () => {
      historyUrl.push(`/${prefixUrl}`);
  };

  const booking = async () => {
  const storedBookingId = sessionStorage.getItem('bookingId');

  if (storedBookingId) {
    return goToNextStep(storedBookingId);
  }

  const {
    data: {
      status,
      booking,
      message,
      restart
    }
  } = await requestApi('/activities/booking/create', 'POST', {transactions, bookingType: 3}, null, true);

  if (status === 'success') {
    sessionStorage.setItem('bookingId', booking.id);
    return goToNextStep(booking.id);
  } else {
    showAlertAutoDis({title: 'Error', text: message}, () => {
      if (restart)
        restartBooking(trip.TripId);
    });
  }
};

  const goToNextStep = (bookingId) => {
    if (bookingType === 'pay')
      history.push(`/${prefixUrl}/${bookingId}/payment`);
    else
      history.push(`/${prefixUrl}/${bookingId}/hold/`);
    // history.push(`/${prefixUrl}${nextStep.url}`);
    // const nextStep = getNextStep(step);
  };


  return (
      <>
        <GuestBar>
          <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
            <Typography color="text.primary">Day Trip Bookings - Review</Typography>
          </Breadcrumbs>
        </GuestBar>

        <Container maxWidth="lg">
          <DayTripStepper/>
          <div style={{marginTop: 50}}/>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={9}>
                  <ActivityBookingReview clientName={clientName}
                                         setClientName={setClientName} clientBookingRef={clientBookingRef}
                                         setClientBookingRef={setClientBookingRef}/>
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Paper style={{marginTop: 20}}>
                    <Button color={'primary'} variant={'contained'} fullWidth onClick={booking}>
                      Next Step
                    </Button>
                    <ListItem alignItems={"center"} style={{justifyContent: 'center', margin: 0, padding: 15}}>
                      <FormControl component="fieldset" className={'bookingOptions'}>
                        <RadioGroup aria-label="typeBooking" name="typeBooking" value={bookingType}
                                    onChange={setBooking}>
                          <FormControlLabel value="pay" control={<Radio color="default"/>} label="Book Now"
                                            style={{fontSize: 20}}/>
                          <Typography color="textSecondary" variant="body2"
                                      style={{marginLeft: 33, fontSize: '1.3rem'}}>
                            Invoice to your account or pay now by credit card
                          </Typography>
                          <FormControlLabel value="hold" control={<Radio color="default"/>}
                                            label="Hold" style={{fontSize: 20}}/>
                          <Typography color="textSecondary" variant="body2"
                                      style={{marginLeft: 33, fontSize: '1.3rem'}}>
                            Let us hold your booking for 72 hours, no questions asked
                          </Typography>
                        </RadioGroup>
                      </FormControl>
                    </ListItem>
                    <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                      Add Another Activity
                    </Button>
                  </Paper>
                  <Itinerary removable={true}/>
                </Grid>
              </Grid>
        </Container>
      </>
  );
};

export default DayTripReviewPage;
